import React from "react";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import SetMealIcon from "@mui/icons-material/SetMeal";

const Banner = () => {
  return (
    <Box marginTop={{ xs: "20%", sm: "5%" }}>
      <Box
        // display={"flex"}
        // justifyContent={"space-between"}
        alignItems={"center"}
        width={"100%"}
      >
        <Typography
          variant={"h3"}
          fontWeight={700}
          textAlign={"center"}
          color={"#fff"}
        >
          Advisory Council
        </Typography>
        <Stack
          spacing={2}
          width={{ xs: "75%", sm: "20%" }}
          paddingTop={{ xs: "5%", sm: "1%" }}
          //   display={{ xs: "none", sm: "block" }}
        >
          <Breadcrumbs
            separator={
              <SetMealIcon
                fontSize="medium"
                sx={{
                  color: "#fff",
                }}
              />
            }
            aria-label="breadcrumb"
          >
            <Link
              underline="hover"
              fontWeight={700}
              key="1"
              href="/"
              sx={{
                color: "#fff",
                fontSize: "18px",
                "&:hover": { color: "#00AEEF" },
              }}
            >
              Home
            </Link>
            <Link
              underline="hover"
              fontWeight={700}
              key="1"
              href="/advisory-council"
              sx={{
                color: "#00AEEF",
                fontSize: "18px",
                "&:hover": { color: "#fff" },
              }}
            >
              Advisory Council
            </Link>
          </Breadcrumbs>
        </Stack>
      </Box>
    </Box>
  );
};

export default Banner;
